/**
 * Abstract renderer interface
 * Allows swapping Three.js for other renderers (WebGPU, 2D canvas, etc.)
 */

export interface IRenderer {
  /**
   * Initialize the renderer with a canvas element
   */
  initialize(canvas: HTMLCanvasElement): Promise<void>;

  /**
   * Render a frame with the given entity positions
   * @param positions Float32Array with x,y,z triplets
   * @param entityCount Number of entities in the positions array
   */
  render(positions: Float32Array, entityCount: number): void;

  /**
   * Handle canvas resize
   */
  resize(width: number, height: number): void;

  /**
   * Clean up resources
   */
  dispose(): void;

  /**
   * Check if renderer is initialized
   */
  isInitialized(): boolean;
}

export interface RendererOptions {
  maxEntities?: number;
  backgroundColor?: number;
  sphereRadius?: number;
}

export const DEFAULT_RENDERER_OPTIONS: Required<RendererOptions> = {
  maxEntities: 10000,
  backgroundColor: 0x0d0d1a,
  sphereRadius: 2,
};
